export class CategoryModel {
  id:	string;
  baseID:	string;
  brandID:	string;
  name:	string;
  state:	string;
  lastModDate:	string;
}
